<template>
  <div class="text--primary">
    <v-row dense>
      <v-col cols="12" sm="6" class="text-truncate">
        <template v-if="itemAprovacao.produto && itemAprovacao.produto.codigo">
          <span class="font-weight-bold">Código interno:</span>
          {{ itemAprovacao.produto.codigo }}
          <v-icon small>mdi-pound</v-icon>
        </template>
        <px-situacao-aprovacao class="ml-3" :situacao="itemAprovacao.situacao"/>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <px-aprovacao-solicitacao-produto-controls show-as-buttons
                                                   :aprovacao-id="aprovacaoId"
                                                   :item-aprovacao="itemAprovacao"
                                                   @update="onUpdate"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="body-1 font-weight-bold">
        <px-produto-descricao v-if="itemAprovacao.produto"
                              :show-codigo="false"
                              :especificacao="itemAprovacao.especificacaoProduto"
                              :produto="itemAprovacao.produto"/>
        <span v-if="!itemAprovacao.produto">
            {{ itemAprovacao.especificacaoProduto }}
          </span>
        <px-resumo-produto-dialog v-if="hasProduto"
                                  :produto="itemAprovacao.produto"
                                  :unidade-medida="itemAprovacao.unidadeMedida"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        {{ itemAprovacao.quantidade }}
        {{ itemAprovacao.unidadeMedida.descricao }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="hasProduto">
        <span class="caption font-weight-bold">Especificação</span>
        <div>
          {{ itemAprovacao.especificacaoProduto | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Centro de custo</span>
        <div>
          {{ centroCusto | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Projeto</span>
        <div>
          {{ projeto | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Data de entrega solicitada</span>
        <div>
          {{ itemAprovacao.dataPrevisaoEntrega | date | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Finalidade da compra</span>
        <div v-if="itemAprovacao.finalidadeCompra">
          <px-finalidade-compra-value :finalidade-compra="itemAprovacao.finalidadeCompra"/>
        </div>
        <div v-else>
          Não informado
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="itemAprovacao.observacaoInterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações externas</span>
        <div>
          <px-show-large-text :large-text="itemAprovacao.observacaoExterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="3" v-if="hasProduto && itemAprovacao.produto.precoTarget">
        <span class="caption font-weight-bold">Preço target</span>
        <div>
          {{ itemAprovacao.produto.precoTarget | currency }}
        </div>
      </v-col>
      <v-col cols="12" sm="3" v-if="itemAprovacao.arquivos && itemAprovacao.arquivos.length">
        <span class="caption font-weight-bold">Anexos</span>
        <px-anexo-chip :files="itemAprovacao.arquivos"
                       download-base-path="files/download-comprador"/>
      </v-col>
    </v-row>
    <v-row v-if="itemAprovacao.motivoRecusa">
      <v-col cols="12">
        <span class="caption font-weight-bold">
          <v-icon small color="warning" class="pb-1">mdi-alert</v-icon> Motivo da recusa
        </span>
        <div>
          {{ itemAprovacao.motivoRecusa }}
        </div>
      </v-col>
    </v-row>
    <px-campos-integracao
      v-if="cadastrosAdicionaisItem && showCadastrosAdiciaonaisItem"
      type="requisicao-produtos-view"
      :form-data="cadastrosAdicionaisItem"/>
  </div>
</template>

<script>
import { TipoProduto, ErpCamposIntegracao } from 'px-business-components';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import { mapGetters } from 'vuex';
import AprovacaoSolicitacaoProdutoControls
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutoControls.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
    itemAprovacao: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    hasProduto() {
      return !!this.itemAprovacao.produto;
    },
    centroCusto() {
      return this.itemAprovacao.centroCusto
        ? descWithCodigoInterno(this.itemAprovacao.centroCusto) : null;
    },
    projeto() {
      return this.itemAprovacao.projeto
        ? descWithCodigoInterno(this.itemAprovacao.projeto) : null;
    },
    showCadastrosAdiciaonaisItem() {
      if (this.erpCamposIntegracao === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
        return this.itemAprovacao.produto
          ? this.itemAprovacao.produto.tipoProduto === TipoProduto.keys.PRODUTO.key : true;
      }
      return this.erpCamposIntegracao !== null;
    },
    cadastrosAdicionaisItem() {
      if (!this.itemAprovacao.cadastrosAdicionais
        || !this.itemAprovacao.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.itemAprovacao.cadastrosAdicionais);
    },
  },
  methods: {
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoProdutoControls: AprovacaoSolicitacaoProdutoControls,
  },
};
</script>
